import React from 'react';

import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';

import { basketActions } from '../../../weborder/redux';
import { paymentSelectors } from '../../../weborder/selectors';
import { RadioGroupList } from '../../molecules/ControlGroup/RadioGroupList';
import { getPaymentOptionsDetails } from './utils/paymentOptionsUtils';

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type PaymentMethodSelectorProps = {
  disabled?: boolean;
  payments: ReturnType<typeof paymentSelectors.getAvailablePayments>;
  selectedPaymentId?: string;
  translate: ReturnType<typeof getTranslate>;
};
type Props = PaymentMethodSelectorProps & DispatchProps;

export const PaymentMethodSelectorComponent = (props: Props) => {
  const {
    disabled,
    payments,
    selectedPaymentId,
    selectPayment,
    translate,
  } = props;

  const renderRadioOption = (disabled, payment) => {
    const { icon, fdKey, text } = getPaymentOptionsDetails(payment, translate);
    return {
      label: (
        <>
          {icon} {text.toString()}
        </>
      ),
      testId: fdKey,
      disabled: disabled || payment.status !== 'success',
      key: payment.paymentId,
      value: payment.paymentId,
    };
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    selectPayment(event.target.value);

  const items = payments.map((payment) => {
    return renderRadioOption(disabled, payment);
  });

  return (
    <RadioGroupList
      options={items}
      aria-label={translate('Payment_methods') as string}
      name="payment_method_selection"
      onChange={handleChange}
      // passing empty string if no init value coz RadioGroup is switching between controlled and uncontrolled state
      value={selectedPaymentId || ''}
    />
  );
};

const mapDispatchToProps = (dispatch) => ({
  selectPayment: (paymentId: string) => {
    dispatch(basketActions.selectPayment({ paymentId }));
  },
});

export default connect(
  null,
  mapDispatchToProps,
)(PaymentMethodSelectorComponent);
